import {Link} from 'gatsby'
import React from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import '../styles/font-preview-list.css'
import FontPreview from './font-preview'

var settings = {
  arrows: false,
  infinite: true,
  speed: 700,
  autoplay: true,
  slidesToScroll: 1,
  swipeToSlide: true,
  dots: true,
};

function FontPreviewList (props) {

  return (
    <div className="font-preview-list">
      <div className="wrapper">
        {props.title && props.browseMoreHref && <h3 className="preview"><Link to={props.browseMoreHref}>{props.title}</Link></h3>}
      </div>
      <div id="font-preview-list">

          <Slider {...settings}>
          {props.nodes &&
            props.nodes.map(node => (
                  <FontPreview {...node} />
          ))}
          </Slider>

      </div>
    </div>
  )
}

FontPreviewList.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: ''
}

export default FontPreviewList